import React, { useContext, useEffect, useState } from 'react'
import { FormGroup, Col, Label } from 'reactstrap'
import Resx from '@/components/Resx'
import { Validator } from '@/components/validation'
import { DropDownList } from '@/components/dropDownList'
import context from '@/context'
import { useLocalization } from '@/hooks/localization'
import { ValidationContext } from '@/components/validation/validationContext'

function BankReportInputs ({ value, onChange }) {
  const { localize } = useLocalization()
  const [bank, setBank] = useState(value.bankId)
  const [submission, setSubmission] = useState(value.reportGroupSubmissionId)
  const validationContext = useContext(ValidationContext)

  // Clear dependant fields
  useEffect(() => {
    validationContext.resetErrors(['companyId', 'makerUserId', 'reportGroupSubmissionId'])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function onBankChange ({ item }) {
    setBank(item)
    setSubmission(null)
    onChange({ ...value, bankId: item ? item.id : null, reportGroupSubmissionId: null })
  }

  function onSubmissionChange ({ item }) {
    setSubmission(item)
    onChange({ ...value, reportGroupSubmissionId: item ? item.id : null })
  }

  function setBankFilter (request) {
    if (!request.filter) {
      request.filter = { filters: [] }
    }
    request.filter.logic = 'and'
    request.filter.filters.push({ field: 'institutionId', operator: 'eq', value: bank ? bank.institutionId : 0 })
    return request
  }

  return (
    <FormGroup row>
      <Label sm='2' className='label'><Resx name='Tickets.SelectBank' /></Label>
      <Col sm='4'>
        <Validator name='bankId' value={value.bankId} required>
          <DropDownList className='bankSelector'
            dataSource={context.api.bankService.getBanks}
            onChange={onBankChange} value={bank} />
        </Validator>
      </Col>
      <Label sm='2' className='label'><Resx name='Tickets.ReportSubmissionGroup' /></Label>
      <Col sm='4'>
        <Validator name='reportGroupSubmissionId' value={value.reportGroupSubmissionId} required>
          <DropDownList className='reportSelector'
            key={bank ? bank.id : 0}
            disabled={!bank}
            dataSource={request => context.api.reportSubmissionGroupService.getTableData(localize('Common.CBI'), false, setBankFilter(request))}
            onChange={onSubmissionChange} value={submission} />
        </Validator>
      </Col>
    </FormGroup>
  )
}

export {
  BankReportInputs
}



// WEBPACK FOOTER //
// ./src/dialogs/ticketTypes/bankReport.js